import { Typography } from "@packages/ds";
import styled from "styled-components";

import { semiBoldAlias } from "Libs/theme";

export const Details = styled.div`
  padding: 32px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const DateRange = styled(Typography.BodyText)`
  color: var(--mode-text-neutral-default-weak);
  margin-top: 4px;
`;

export const Info = styled.div`
  display: block;
  margin-top: 16px;
`;

export const Label = styled.span`
  display: block;
  color: ${props =>
    props.theme.name === "contrast"
      ? "#4A495E"
      : "var(--mode-text-neutral-weakest)"};
  font-size: 13px;
  line-height: 16px;
  ${semiBoldAlias()};
  &:first-letter {
    text-transform: uppercase;
  }
`;

export const Value = styled.span`
  display: flex;
  justify-content: flex-start;
  gap: 8px;
  align-items: center;
  margin-bottom: 4px;
  font-size: 15px;
  line-height: 18px;
  position: relative;
  ${semiBoldAlias()};
  color: var(--mode-text-neutral-default);
`;

export const Infos = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`;
